import { Injectable } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { CookieService } from 'ngx-cookie';
import { CookieConsentSnackbarComponent } from '../components/cookie-consent-snackbar/cookie-consent-snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class AppCookiesService {
  constructor(private cookieService: CookieService) {}

  private snackbarRef: MatSnackBarRef<CookieConsentSnackbarComponent>;

  public init(): void {
    if (!this.cookieService.get('allow_cookies')) {
      setTimeout(() => {
        // this.snackbarRef = this.snackbar.openFromComponent(CookieConsentSnackbarComponent, {
        //   panelClass: 'cookie-consent',
        // });
        //
        // this.snackbarRef.afterDismissed().subscribe((dismiss: MatSnackBarDismiss) => {
        //   if (dismiss.dismissedByAction) {
        //     const expires = new Date();
        //     expires.setTime(expires.getTime() + 365 * 24 * 60 * 60 * 1000);
        //     this.cookieService.put('allow_cookies', 'allow', { expires });
        //   }
        // });
      });
    }
  }

  public closeBanner(): void {
    if (this.snackbarRef) {
      this.snackbarRef.dismissWithAction();
    }
  }
}
